<div class="bigChartThumbnail" id="{{id}}" [ngStyle]="style">
    <img (click)="pClick()" class="bigChartThumbnailImg" loading="lazy" data-id="{{chart.id}}" [ngStyle]="imgStyle" alt="{{chart.title}}" src="{{chart.imageUrl}}" title="{{chart.title}}">
  <div (click)="pClick()" *ngIf="index" class="bNumber">{{index}}</div>
  <a *ngIf="permalink" class="bLink" href="{{chart.webLink}}" title="Display this Chart only" target="_blank">
    <fa-icon [icon]="['fas','link']"></fa-icon>
  </a>
  <div (click)="pClick()" class="chartLabel">{{chart.title}}</div>
</div>